import React from "react";
import ReadonlyField from "./ReadonlyField";
import { COLORS } from "../constants";
import { PrivateSector } from "../types";

const SIMAH_HEADER_LABELS = {
  basicSalary: "Basic",
  housingAllowance: "Housing",
  otherAllowance: "Other Allowance",
  employerName: "Employer Name",
  dateOfJoining: "Date of Joining (G)",
  payMonth: "Pay Month",
  workingMonths: "Working Months",
  sector: "Employment Sector",
  netIncome: "Net Income",
  agencyCode: "Agency Code",
  agencyName: "Agency Name",
  agencyEmploymentDate: "Agency Employment Date",
  totalDeductions: "Total Deductions",
  totalAllowances: "Total Allowances",
};

const SIMAH_HEADERS = [
  "basicSalary",
  "housingAllowance",
  "otherAllowance",
  "employerName",
  "dateOfJoining",
  "payMonth",
  "workingMonths",
  "sector",
  "netIncome",
  "agencyCode",
  "agencyName",
  "agencyEmploymentDate",
  "totalDeductions",
  "totalAllowances",
] as const;

interface DataProps {
  data?: any;
  netIncome?: string;
  masdarSalary?: PrivateSector;
}

const formatPayMonth = (value?: string): string => {
  if (!value) return "-";
  
  try {
    // Check if value is in YYYYMM format (6 digits)
    if (typeof value === "string" && /^\d{6}$/.test(value)) {
      const year = parseInt(value.substring(0, 4), 10);
      const month = parseInt(value.substring(4, 6), 10);
      
      if (year > 0 && month >= 1 && month <= 12) {
        const monthNames = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        return `${monthNames[month - 1]} ${year}`;
      }
    }
    
    // Return original value if format doesn't match
    return value;
  } catch {
    return value || "-";
  }
};

const SimahViewSalaryDetailsView: React.FC<DataProps> = ({ data, netIncome, masdarSalary }) => {
  const BASIC_DATA = [];
  if (data) {
    BASIC_DATA.push({
      ...data,
      netIncome: netIncome ?? "-",
      basicSalary: masdarSalary?.basicWage || data?.basicSalary,
      housingAllowance: masdarSalary?.housingAllowance || data?.housingAllowance,
      otherAllowance: masdarSalary?.otherAllowance || data?.otherAllowance
    });
  } else {
    BASIC_DATA.push({
      basicSalary: "-",
      housingAllowance: "-",
      otherAllowance: "-",
      employerName: "-",
      dateOfJoining: "-",
      payMonth: "-",
      workingMonths: "-",
      sector: "-",
      netIncome: "-",
      agencyCode: "-",
      agencyName:"-",
      agencyEmploymentDate: "-",
      totalDeductions: "-",
      totalAllowances: "-",
    });
  }
  return (
    <div className="container mt-4">
      <div className="row">
        <ReadonlyField label="ID Number" value="" />
        <ReadonlyField
          label="Reference Number"
          value=""
          icon="bi bi-info-circle"
        />
      </div>
      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {SIMAH_HEADERS.map((key) => (
              <th key={key}>{SIMAH_HEADER_LABELS[key]}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {BASIC_DATA.map((row, i) => (
            <tr key={i}>
              {SIMAH_HEADERS.map((key) => (
                <td key={key}>
                  {key === "payMonth" 
                    ? formatPayMonth(row[key]) 
                    : (row[key] ?? "-")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimahViewSalaryDetailsView;
